<script src="./mvt-propertymarker.js"></script>

<template>
  <CustomMarker :options="{ position }" class="pin-house" :class="[ {'pin-selected': isSelected}, dynamicClass]">
    <div
        class="mvt-propertymarker"
        ref="markerRef">
      <div
          class="mvt-propertymarker__button"
          @click="() => setSelected()"
          ref="buttonRef"
      >
        <div
            v-if="(!showPrice || !isSingleProperty) && !isHomePin"
            class="mvt-propertymarker__dot"
            :class="{'mvt-propertymarker__dot--group': !isSingleProperty}"
        >
          <span v-if="!isSingleProperty">{{ properties.length }}</span>
        </div>
        <div
            v-if="showPrice && isSingleProperty && !isHomePin"
            class="mvt-propertymarker__price"
            :sub="dynamicSubtext"
        >
          <span>
            <i v-if="dynamicIcon" :class="dynamicIcon"></i>
            {{ formattedPrice }}</span>
        </div>
        <div
            v-if="isHomePin"
            class="mvt-propertymarker__pin"
        >
          <i :class="dynamicIcon"></i>
        </div>
      </div>
      <div
          v-if="isSelected && !disablePopup"
          ref="cardRef"
          class="mvt-propertymarker__card"
          :style="`--property-market-x: ${positionX}%; --property-market-y: ${positionY}%; visibility: ${isVisibility ? 'visible' : 'hidden'};`"
      >
        <mvtCardProperty
            v-if="isSingleProperty"
            :data="property"
            :theme="'style4'"
        />
        <mvtCardHouseList
            v-if="!isSingleProperty"
            :data="properties"
            @mouseenter.stop.prevent="disableMapScroll"
            @mouseleave.stop.prevent="enableMapScroll"
            @dragstart.stop.prevent="disableMapScroll"
            @dragend.stop.prevent="enableMapScroll"
        />
      </div>
    </div>
  </CustomMarker>
</template>

<style lang="scss">

.pin-house{
  --map-marker-color-bg: var(--color-brand);
  --map-marker-color-border: var(--color-f);
  --map-marker-color: var(--color-f);
  --map-marker-color-bg-hover: var(--color-main);
  --map-marker-color-border-hover: var(--color-f);
  --map-marker-color-hover: var(--color-default-bg);
  --map-marker-sub-color: var(--color-default);
  --map-marker-sub-color-bg: var(--color-bg);
  --map-marker-sub-color-border: var(--color);
  --map-marker-box-shadow: 0px 2px 4px 0px rgba(33,33,33,.3);

  &.sold {
    --map-marker-color-bg: var(--color-default-bg);
    --map-marker-color-border: var(--color-default-bg);
    --map-marker-color: var(--color-default);
    --map-marker-color-bg-hover: var(--color-main);
    --map-marker-color-border-hover: var(--color-main);
    --map-marker-color-hover: var(--color-f);
    --map-marker-sub-color: var(--color-default-bg);
    --map-marker-sub-color-bg: var(--color-default);
    --map-marker-sub-color-border: var(--color-default)
  }

  &.new {
    --map-marker-sub-color-bg: var(--color-springgreen);
    --map-marker-sub-color-border: var(--color-springgreen)
  }

  &.pending {
    --map-marker-sub-color-bg: var(--color-default);
    --map-marker-sub-color-border: var(--color-default);
    --map-marker-sub-color: var(--color-bg)
  }

  &.viewed {
    --map-marker-color-bg: #7a9e98;
    --map-marker-color: var(--color-bg);
    --map-marker-color-bg-hover: #7a9e98;
    --map-marker-color-hover: var(--color-bg)
  }

  &.viewed.sold {
    --map-marker-color-bg: var(--color-e);
    --map-marker-color-border: var(--color-e);
    --map-marker-color: var(--color-7);
    --map-marker-color-bg-hover: var(--color-e);
    --map-marker-color-border-hover: var(--color-e);
    --map-marker-color-hover: var(--color-7)
  }

  &.home {
    --map-marker-color-bg: var(--color-brand);
    --map-marker-color-border: var(--color-brand);
    --map-marker-color: var(--color-f);
    --map-marker-sub-color-bg: var(--color-default-bg);
    --map-marker-sub-color-border: var(--color-default-bg);
  }
}
.mvt-propertymarker {
  position: relative;
  &__button {

    &:hover,
    &--hovered {
      cursor:pointer;



    }

    &--selected {

      .mvt-propertymarker__dot,
      .mvt-propertymarker__price {
        color: var(--map-marker-color-hover);
        background-color: var(--map-marker-color-bg-hover);
        box-shadow: 0 0 0 1px var(--map-marker-color-border-hover), var(--map-marker-box-shadow);
        transform: scale(1.5) !important;
      }

      .mvt-propertymarker__pin {
        color: var(--map-marker-color-bg-hover);
        transform: scale(1.5) !important;
      }

    }

  }

  &__dot,
  &__price,
  &__pin {
    cursor:pointer;
    transition: transform 0.1s ease-in;
    z-index: 1;
    transform-origin: center center;
  }

  &__dot {
    width: 0.5rem;
    height: 0.5rem;
    background-color: var(--map-marker-color-bg);
    border-radius: 50%;
    box-shadow: 0 0 0 1px var(--map-marker-color-border), var(--map-marker-box-shadow);
    font-size: var(--font-size-8);
    line-height: var(--line-height-3);
    color: var(--map-marker-color);

    &--group {
      height: 1rem;
      width: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.5rem;
    }
    &:hover{
      transform: scale(1.5);
      color: var(--map-marker-color-hover);
      background-color: var(--map-marker-color-bg-hover);
      box-shadow: 0 0 0 1px var(--map-marker-color-border-hover), var(--map-marker-box-shadow);
    }
  }

  &__price {
    background-color: var(--map-marker-color-bg);
    box-shadow: 0 0 0 1px var(--map-marker-color-border), var(--map-marker-box-shadow);
    position: relative;
    border-radius: .618rem;
    cursor: pointer;
    display: block;
    font-size: 0.625rem;
    line-height: 1.5;
    position: relative;
    transition: transform .25s;
    color: var(--map-marker-color);
    transform: scale(1.25);

    & > span {
      border-radius: .618rem;
      display: inline-block;
      padding: 1px 0.25rem 0;
      text-align: center;
    }

    &[sub]:before {
      background-color: var(--map-marker-sub-color-bg);
      border-radius: 12px;
      box-shadow: 0 0 0 1px var(--map-marker-sub-color-border);
      color: var(--map-marker-sub-color);
      content: attr(sub);
      display: inline-block;
      padding: 0 0.25rem;
      position: absolute;
      right: 0;
      text-transform: uppercase;
      top: 0;
      transform: translateY(-60%) scale(.6);
      transform-origin: right center;
      white-space: nowrap;
      z-index: 2;
    }
    &:hover{
      transform: scale(1.5);
      color: var(--map-marker-color-hover);
      background-color: var(--map-marker-color-bg-hover);
      box-shadow: 0 0 0 1px var(--map-marker-color-border-hover), var(--map-marker-box-shadow);
    }
  }

  &__pin {
    color: var(--map-marker-color-bg);
    font-size: 2rem;
    line-height: var(--line-height-1);
    margin-top: 3px;
    position: relative;
    transform-origin: center bottom !important;
    transform: scale(1.25);
    z-index: 1;
    &:hover{
      transform: scale(1.5);
      color: var(--map-marker-color-bg-hover);
    }
    &>i{
      &:after{
        content: " ";
        background-color: var(--color-bg);
        display: block;
        height: 15px;
        width: 15px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -75%);
        z-index: -1;
      }
    }
  }

  &__card {
    position: absolute;
    left: 0;
    top: 0;
    width: 22.5rem;

    /* Default */
    transform: translate(var(--property-market-x), var(--property-market-y));

    & > div {
      position: relative;
    }

    .card-houselist-items {

      .img {
        height: 3.5rem;
        width: 5rem;
      }

    }

  }

}

</style>